// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import VueCarousel from 'vue-carousel';
import Buefy from 'buefy'
import panZoom from 'vue-panzoom'
import Vue3TouchEvents from "vue3-touch-events";
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import router from './router'
// import VueLazyload from "vue-lazyload";

import 'buefy/dist/buefy.css'
import './assets/css/main.css'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

// or with options
// const loadimage = require('./assets/loading.gif')
// const errorimage = require('./assets/error.gif')

// Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   // error: errorimage,
//   // loading: loadimage,
//   attempt: 1
// })

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(Vue3TouchEvents);
Vue.use(VueCarousel);
Vue.use(Buefy)
Vue.use(panZoom);
// Vue.use(VueLazyload);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js